import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Container, Flex, Grid } from '@chakra-ui/react';
import { Logo } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useCustomLocale } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import { containerLogoStyle, containerWrapperStyles, contentStyles, headerWrapperStyles } from '../HeaderLeisure.style';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HeaderVariantLogo(_ref) {
  var _headerInfoData$conte;
  var headerInfoData = _ref.headerInfoData,
    hotelBrand = _ref.hotelBrand,
    isIcon = _ref.isIcon,
    _ref$bb = _ref.bb,
    bb = _ref$bb === void 0 ? false : _ref$bb;
  var _useCustomLocale = useCustomLocale(),
    currentLanguage = _useCustomLocale.language,
    currentCountry = _useCustomLocale.country;
  var isWindowDefined = typeof window !== 'undefined';
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    origin = _useState2[0],
    setOrigin = _useState2[1];
  useEffect(() => {
    setOrigin(window.location.origin);
  }, [isWindowDefined]);
  return _jsx(Box, _objectSpread(_objectSpread({}, customHeaderWrapperStyles), {}, {
    "data-testid": "common-header-wrapper",
    children: _jsx(Container, _objectSpread(_objectSpread({}, containerWrapperStyles), {}, {
      children: _jsx(Grid, _objectSpread(_objectSpread({}, contentStyles), {}, {
        sx: {
          '@media print': {
            py: 'sm'
          }
        },
        children: _jsx(Flex, _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
          "data-testid": "logo-container",
          children: _jsx(Logo, {
            src: formatAssetsUrl(headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte = headerInfoData.content) === null || _headerInfoData$conte === void 0 || (_headerInfoData$conte = _headerInfoData$conte.header) === null || _headerInfoData$conte === void 0 ? void 0 : _headerInfoData$conte.image),
            href: "".concat(origin, "/").concat(currentCountry, "/").concat(currentLanguage, "/").concat(bb ? 'business-booker/home.html' : 'home.html'),
            variant: isIcon && hotelBrand === 'pi' ? 'pi-icon' : hotelBrand
          })
        }))
      }))
    }))
  }));
}
var customHeaderWrapperStyles = _objectSpread(_objectSpread({}, headerWrapperStyles), {}, {
  h: {
    mobile: 'var(--chakra-space-4xl)',
    lg: 'var(--chakra-space-6xl)'
  }
});